import { useSelector } from 'react-redux'

import { useFeatureValue } from '@growthbook/growthbook-react'

import { selectGrowthbookFeatureKey } from 'root-redux/selects/common'

import {
  getStepsVariantFromSegmentName,
  isStepsSegmentName,
} from 'helpers/stepsVariant'

import { PAGES_SEGMENTS } from 'root-constants'
import { TStepsVariant } from 'root-types'

const FALLBACK_STEPS_VARIANT: TStepsVariant = PAGES_SEGMENTS.VARIANT_A

export const useStepsVariant = (): TStepsVariant => {
  const growthbookFeatureKey = useSelector(selectGrowthbookFeatureKey)

  const segmentName = useFeatureValue(growthbookFeatureKey, '')

  return isStepsSegmentName(segmentName)
    ? getStepsVariantFromSegmentName(segmentName)
    : FALLBACK_STEPS_VARIANT
}
